export const mapGenderIdsToObject = (arr: number[]): Record<number, true> => {
  return arr.reduce(
    (acc, id) => ({ ...acc, [id]: true }),
    {} as Record<number, true>
  );
};
